import OnlineVisitRequest, {
  mapStateToProps,
} from '../../../../../pages/vip/features/online-visit-request-label/online-visit-request-label';

export default OnlineVisitRequest;

export { mapStateToProps };
